import React from "react";
import {
  Button,
  EmployeeHeader,
  NewTab,
  PageHeader,
  PageTab,
} from "../../../../components";
import WorkList from "./Timesheets/WorkList";
import TimesheetsTab from "./Timesheets/TimesheetsTab";

const Timesheets = () => {
  const TimesheetMenus = [
    {
      title: "Timesheets",
      page: <TimesheetsTab />,
      type: "main",
    },
    //as new changes on 29-05-2025
    // {
    //   title: "Work List",
    //   page: <WorkList />,
    //   type: "main",
    // },
  ];
  return (
    <div className="mt-3 flex-1 flex flex-col gap-2 overflow-hidden">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                color="primary"
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
              /> */}
            </div>
          }
        />
      </div>
      <div className="flex-1 flex flex-col gap-2 overflow-hidden">
        <NewTab
          tabs={TimesheetMenus}
          color="black"
          variant="outlined"
          //mainTabsShow={2}
          mode="url"
          tabId="timesheets"
        />
      </div>
    </div>
  );
};

export default Timesheets;
